/**
 * Caixa — o fechamento por turno.
 *
 * Mesma casca visual de `OrderReport.ts` (card com ícone e título), só com o
 * que esta tela usa. O corpo do relatório é o `DynamicTable` e os blocos de
 * `reports/RelatorioComum.ts` — nenhum tema novo entra aqui.
 */
import styled from "styled-components";

export const CashReportContainer = styled.div`
  opacity: 1;
  z-index: 2;
  padding: var(--sp-20);
`;

export const Card = styled.div`
  background-color: ${(props) => props.theme.colors.background + "cc"};
  color: ${(props) => props.theme.colors.text};
  border: 1px solid ${(props) => props.theme.colors.text};
  padding: var(--sp-20);
  border-radius: 8px;
`;

export const Icon = styled.div`
  font-family: "Material Icons";
  text-align: center;
  font-size: var(--fs-5xl);
  color: ${(props) => props.theme.colors.selection};
  text-shadow: -0.5px -0.5px 0 #000, 0.5px -0.5px 0 #000, -0.5px 0.5px 0 #000,
    1px 1px 0 #000;
`;

export const Title = styled.h2`
  text-align: center;
  margin-bottom: var(--sp-10);
  color: ${(props) => props.theme.colors.selection};
  text-shadow: -0.2px -0.2px 0 #000, 0.2px -0.2px 0 #000, -0.2px 0.2px 0 #000,
    0.5px 0.5px 0 #000;
`;
